import { jsx as _jsx } from "react/jsx-runtime";
export function Caret(props) {
    const { flip, style, size, ...rest } = props;
    const flipStyle = { transition: "transform 150ms", transform: `rotate(${flip ? 180 : 0}deg)` };
    return _jsx("svg", { ...rest, style: { ...style, ...flipStyle }, xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 448 512", children: _jsx("path", { fill: "currentColor", d: "M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z" }) });
}
